export function stripHtml(html) {
    if (!html) return "";
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
}

export function clampText(text, max = 220) {
    if (!text) return "";
    if (text.length <= max) return text;
    return text.slice(0, max - 1) + "…";
}
